<template>
  <el-card>
    <div slot="header">
      Alapadatok
    </div>
    <el-form
      ref="basicDataForm"
      :model="basicData.company"
      label-position="top"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item>
            <el-radio-group v-model="basicData.type">
              <el-radio label="COMPANY">Cég</el-radio>
              <el-radio label="INDIVIDUAL">Magánszemély</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Cég rövid neve">
            <el-input
              v-model="basicData.company.short_name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Cég hivatalos neve"
            prop="name"
          >
            <el-input
              v-model="basicData.company.name"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Adószám" prop="tax_number">
            <el-input
              v-model="basicData.company.tax_number"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="EU adószám" prop="eu_tax_number">
            <el-input
              v-model="basicData.company.eu_tax_number"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"></el-col>
        <el-col :span="12">
          <el-form-item label="Harmadik orszgágbeli adószám" prop="non_eu_tax_number">
            <el-input
              v-model="basicData.company.non_eu_tax_number"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Csoportos adószám">
            <el-input
              v-model="basicData.company.group_tax_number"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Cégjegyzék / nyilvántartási szám">
            <el-input
              v-model="basicData.company.registration_number"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="FELIR">
            <el-input
              v-model="basicData.company.felir"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Státusz"
            prop="status"
          >
            <el-select
              v-model="basicData.company.status"
              style="width: 100%"
            >
              <el-option
                label="Aktív"
                value="active"
              />
              <el-option
                label="Inaktív"
                value="inactive"
              />
              <el-option
                label="Tiltott"
                value="forbidden"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="orders_can_be_merged">
            <el-checkbox
              v-model="basicData.orders_can_be_merged"
            >
              Rendelés összevonható
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Típus" prop="company_type" class="is-required">
            <el-checkbox
              v-model="basicData.is_supplier"
              @change="onSupplierChange"
            >
              Beszállító
            </el-checkbox>
            <el-checkbox v-model="basicData.is_customer">
              Vevő
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col
          v-if="basicData.is_supplier"
          :span="12"
        >
          <el-form-item label="Szállítói kategória">
            <el-select
              v-model="basicData.supplier_category_id"
              style="width: 100%;"
            >
              <el-option
                v-for="category in supplierCategories"
                :key="category.id"
                :label="category.value"
                :value="category.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="basicData.is_customer" :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="customer_vat_status"
          >
            <span slot="label">
              NAV vevő státusz
              <el-popover
                placement="top"
                width="520"
                trigger="click"
                style="word-wrap: normal; cursor:pointer">
                <b>Belföldi:</b> Belföldi ÁFA alany<br />
                <b>Magánszemély:</b> Nem ÁFA alany (belföldi vagy külföldi) természetes személy<br />
                <b>Egyéb:</b> belföldi nem ÁFA alany, nem természetes személy, külföldi ÁFA alany és külföldi nem ÁFA alany, nem természetes személy
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </span>
            <el-select
              v-model="basicData.customer_vat_status"
              style="width: 100%;"
            >
              <el-option
                label="Belföldi"
                value="DOMESTIC"
              />
              <el-option
                label="Magánszemély"
                value="PRIVATE_PERSON"
              />
              <el-option
                label="Egyéb"
                value="OTHER"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Vevői kategória"
          >
            <el-select
              v-model="basicData.customer_category_id"
              style="width: 100%;"
            >
              <el-option
                v-for="category in customerCategories"
                :key="category.id"
                :label="category.value"
                :value="category.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="basicData.is_customer && 'OTHER' === basicData.customer_vat_status" :gutter="20">
        <el-col :span="24">
          <el-form-item prop="customer_vat_status_other_type" label="Egyéb vevő típusa">
            <el-radio-group v-model="basicData.customer_vat_status_other_type">
              <el-radio label="NON_VAT">Belföldi, nem adóalany</el-radio>
              <el-radio label="EU">Közösségen (EU) belüli</el-radio>
              <el-radio label="NON_EU">Harmadik országbeli</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Megjegyzés">
            <el-input
              v-model="basicData.company.comment"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Bizonylatokon megjelenő extra információ">
            <el-input
              v-model="basicData.receipt_comment"
              type="textarea"
              :rows="3"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
export default {
  props: ['partner'],
  data() {
    const validateType = (rule, value, callback) => {
      if (!this.basicData.is_supplier && !this.basicData.is_customer) {
        callback(new Error('Legalább 1 partnertípus kiválasztása kötelező.'));
      } else {
        callback();
      }
    };
    const validateTax = (rule, value, callback) => {
      const pattern = /[0-9]{8}-[0-9]{1}-[0-9]{2}/;
      if (!this.basicData.company.tax_number && !this.basicData.company.eu_tax_number && !this.basicData.company.non_eu_tax_number) {
        callback(new Error('Legalább 1 adószám megadása kötelező.'));
      } else if(this.basicData.company.tax_number && !pattern.test(this.basicData.company.tax_number) && this.basicData.type === 'COMPANY') {
        callback(new Error('Érvénytelen formátum'));
        this.$refs['basicDataForm'].clearValidate('eu_tax_number');
        this.$refs['basicDataForm'].clearValidate('non_eu_tax_number');
      } else {
        callback();
        this.$refs['basicDataForm'].clearValidate('eu_tax_number');
        this.$refs['basicDataForm'].clearValidate('non_eu_tax_number');
      }
    };
    const validateEuTax = (rule, value, callback) => {
      if (!this.basicData.company.tax_number && !this.basicData.company.eu_tax_number && !this.basicData.company.non_eu_tax_number) {
        callback(new Error('Legalább 1 adószám megadása kötelező.'));
      } else {
        callback();
        this.$refs['basicDataForm'].clearValidate('tax_number');
        this.$refs['basicDataForm'].clearValidate('non_eu_tax_number');
      }
    };
    const validateNonEuTax = (rule, value, callback) => {
      if (!this.basicData.company.tax_number && !this.basicData.company.eu_tax_number && !this.basicData.company.non_eu_tax_number) {
        callback(new Error('Legalább 1 adószám megadása kötelező.'));
      } else {
        callback();
        this.$refs['basicDataForm'].clearValidate('tax_number');
        this.$refs['basicDataForm'].clearValidate('eu_tax_number');
      }
    };
    const validateCustomerVatStatus = (rule, value, callback) => {
      if (this.basicData.is_customer && !this.basicData.customer_vat_status) {
        callback(new Error('NAV vevő státusz megadása kötelező'));
      } else {
        callback();
      }
    };
    const validateCustomerVatStatusOtherType = (rule, value, callback) => {
      if (this.basicData.customer_vat_status && 'OTHER' === this.basicData.customer_vat_status && !this.basicData.customer_vat_status_other_type) {
        callback(new Error('Valamely egyéb vevő típus választása kötelező'));
      } else {
        callback();
      }
    };

    return {
      basicData: {
        receipt_comment: '',
        type: 'COMPANY',
        company: {},
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Cégnév megadása kötelező',
            trigger: 'change'
          }
        ],
        status: [
          {
            required: true,
            message: 'Státusz megadása kötelező',
            trigger: 'change'
          }
        ],
        tax_number: [
          {
            validator: validateTax,
            trigger: 'change',
          }
        ],
        eu_tax_number: [
          {
            validator: validateEuTax,
            trigger: 'change',
          }
        ],
        non_eu_tax_number: [
          {
            validator: validateNonEuTax,
            trigger: 'change',
          }
        ],
        company_type: [
          {
            validator: validateType,
            trigger: 'change',
          }
        ],
        customer_vat_status: [
          {
            validator: validateCustomerVatStatus,
            trigger: 'change'
          }
        ],
        customer_vat_status_other_type: [
          {
            validator: validateCustomerVatStatusOtherType,
            trigger: 'change'
          }
        ],
      }
    };
  },
  computed: {
    supplierCategories() {
      return this.$store.getters['supplierCategory/supplierCategories'];
    },
    customerCategories() {
      return this.$store.getters['customerCategory/customerCategories'];
    },
  },
  watch: {
    partner(newVal) {
      this.basicData = Object.assign({}, newVal);
    },
  },
  methods: {
    onSupplierChange(value) {
      if (value && !this.basicData.supplier_category_id && this.supplierCategories && this.supplierCategories.length) {
        this.$set(this.basicData, 'supplier_category_id', this.supplierCategories[0].id);
      }
    },
  },
};
</script>

